import { render, staticRenderFns } from "./BcBtnNonconformance.vue?vue&type=template&id=e538e2fc"
import script from "./BcBtnNonconformance.vue?vue&type=script&lang=js"
export * from "./BcBtnNonconformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports